import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=b1139a86&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=b1139a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1139a86",
  null
  
)

export default component.exports